"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.USStateGeoUrl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styling = require("../../toolkit/styling");

var _states = require("../../toolkit/states");

var _ComposableMap = _interopRequireDefault(require("./ComposableMap"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var discussion = "Based on [`ComposableMap`](/lego/component/ComposableMap)";
var USStateGeoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
/* eslint-disable local-rules/unwrapped-i18n */

exports.USStateGeoUrl = USStateGeoUrl;
var propDoc = {
  children: {
    required: true,
    type: "(stateCode: USStateCode) => GeographyProps",
    description: "Provide render settings for a state on the map"
  }
};
var demoProps = {
  style: {
    width: 500,
    height: 500
  },
  children: function children(stateCode) {
    var fill = ["CA", "TX", "NY", "FL", "IL"].includes(stateCode) ? "#afc7d1" : "rgba(175, 199, 209, 0.4)";
    return {
      fill: fill,
      renderPopover: function renderPopover() {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Hello from popover: ", stateCode);
      }
    };
  }
};
var demoRender = "\n<USStateMap\n  style={{\n    width: 500,\n    height: 500\n  }}\n>\n  {stateCode => {\n    const fill = [\"CA\", \"TX\", \"NY\", \"FL\", \"IL\"].includes(stateCode)\n      ? \"#afc7d1\"\n      : \"rgba(175, 199, 209, 0.4)\";\n\n    return { fill, renderPopover: () => <div>Hello from popover: {stateCode}</div> };\n  }}\n</USStateMap>\n";

var USStateMap = function USStateMap(props) {
  var className = props.className,
      style = props.style,
      children = props.children;

  var _useRef = (0, _react.useRef)(Object.keys(_states.states.US).reduce(function (total, stateCode) {
    var stateName = _states.states.US[stateCode];
    return _objectSpread(_objectSpread({}, total), {}, (0, _defineProperty2["default"])({}, stateName.toUpperCase(), stateCode));
  }, {})),
      nameToStateCode = _useRef.current;

  return /*#__PURE__*/_react["default"].createElement(_ComposableMap["default"], {
    geoUrl: USStateGeoUrl,
    className: (0, _styling.css)(className, style),
    projection: "geoAlbersUsa"
  }, function (geo) {
    var stateName = geo.properties.name.toUpperCase();
    return children(nameToStateCode[stateName]);
  });
};

USStateMap.propDoc = propDoc;
USStateMap.demoProps = demoProps;
USStateMap.demoRender = demoRender;
USStateMap.discussion = discussion;
var _default = USStateMap;
exports["default"] = _default;